import React from 'react';
import { EditIcon, Separator } from '../../../../assets/icons';
import { capitalizeWords } from '../../../../utils';

export const StatusBar = ({ lot, setOpenPopBox }) => {
  // const totalSewDamagedQty = lot?.batch?.reduce(
  //   (sum, batch) => sum + (batch?.sew_damage_qty || 0),
  //   0
  // );
  const statusTab = [
    {
      key: 'Lot No',
      value: lot?.lot_no,
    },
    { key: 'SKU', value: lot?.SKU || 'N/A', edit: false },
    { key: 'Order Unit', value: lot?.total_qty, edit: false },
    { key: 'Ready Unit', value: lot?.ready_qty, edit: false },
    { key: 'Total Cut Unit', value: lot?.total_cut_qty, edit: false },
    { key: 'Total Sew Unit', value: lot?.total_sew_qty, edit: false },
    { key: 'Total Damaged Unit', value: lot?.total_damage_qty, edit: false },
    { key: 'Remaining Unit', value: lot?.remaining_qty >= 0 ? lot?.remaining_qty : 0, edit: false },
    {
      key: 'Priority',
      value: lot?.priority ? capitalizeWords(lot?.priority) : '',
      edit: lot.total_qty > lot.ready_qty ? true : false,
    },
    {
      key: 'Ready Status',
      value: lot?.ready_status,
      edit: false,
    },
    // {
    //   key: 'Total Sew Damaged Qty',
    //   value: totalSewDamagedQty,
    //   edit: false,
    // },
  ];
  return (
    <div className="w-100 info-header d-flex align-items-center justify-content-start flex-wrap">
      {statusTab.map((tab) =>
        tab.edit ? (
          <div
            onClick={() => setOpenPopBox(true)}
            key={tab.key}
            className={`bg-white info-txt-box d-flex align-items-center justify-content-center ${tab.key === 'Priority' ? 'pointer' : ''}`}>
            <span>{tab.key}</span>
            <Separator />
            <span>{tab.value}</span>
            <EditIcon />
          </div>
        ) : (
          <div
            key={tab.key}
            className="bg-white info-txt-box d-flex align-items-center justify-content-center">
            <span>{tab.key}</span>
            <Separator />
            <span>{tab.value}</span>
          </div>
        ),
      )}
    </div>
  );
};
